import React from "react";
import { useParams } from "react-router-dom";
import trans from "../../../../utils";
import { InputSelect } from "../../../Helpers/Input/RefactoredInput";

export default function SnagOfflineFormInformation({
	formBody,
	formEditData,
	addData,
}) {
	console.log("FOrmeditdata", formEditData);
	const params = useParams();
	return (
		<div style={{ paddingInline: "16px" }}>
			<p className="fs-16 fw-500 brand-700 text-capitalize">
				{trans("general information")}
			</p>
			<div className="row gy-2">
				<div className="col-lg-12">
					<InputSelect
						label="projects"
						name="project_id"
						id="project_id"
						options={[
							{
								label: formBody?.project?.name,
								value: formBody?.project?.id,
							},
						]}
						value={
							!params?.id ? formBody?.project?.id : formEditData?.project_id
						}
						disabled={true}
					/>
				</div>
				<div className="col-lg-12">
					<InputSelect
						label="Building"
						name="zone_id"
						id="zone_id"
						options={[
							{
								label: formBody?.building?.name,
								value: formBody?.building?.id,
							},
						]}
						value={!params?.id ? formBody?.building?.id : formEditData?.zone_id}
						disabled={true}
					/>
				</div>
				<div className="col-lg-12">
					<InputSelect
						label="level"
						name="level"
						id="level"
						options={[
							{
								label: formBody?.level?.name,
								value: formBody?.level?.id,
							},
						]}
						value={!params?.id ? formBody?.level?.id : formEditData?.level}
						disabled={true}
					/>
				</div>
				<div className="col-lg-12">
					<InputSelect
						label="Space"
						name="room_id"
						id="room_id"
						options={formBody?.rooms?.map((i) => ({
							label: i?.displayName,
							value: i?.poiId,
						}))}
						onBlur={(e) => addData.handleBlur(e)}
						onChange={(value) => {
							addData.setFieldValue("room_id", value);
							const roomLabel = formBody?.rooms?.find(
								(i) => i?.poiId === value,
							)?.displayName;
							addData.setFieldValue("room_name", roomLabel);
						}}
						value={addData.values.room_id || undefined}
						allowClear={false}
						touched={addData.touched.room_id}
						errors={addData.errors.room_id}
						placeholder={trans("Select Space")}
						// value={formBody?.project?.id}
					/>
				</div>
			</div>
		</div>
	);
}
